/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Demo_Sub_GeneralInputs */

const en_funnel_ob_demo_sub_general = /** @type {(inputs: Funnel_Ob_Demo_Sub_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a voice and press play. Natural, human, and easy to follow along.`)
};

const es_funnel_ob_demo_sub_general = /** @type {(inputs: Funnel_Ob_Demo_Sub_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una voz y dale a reproducir. Natural, humana y fácil de seguir.`)
};

/**
* | output |
* | --- |
* | "Pick a voice and press play. Natural, human, and easy to follow along." |
*
* @param {Funnel_Ob_Demo_Sub_GeneralInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_demo_sub_general = /** @type {((inputs?: Funnel_Ob_Demo_Sub_GeneralInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Demo_Sub_GeneralInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_demo_sub_general(inputs)
	return en_funnel_ob_demo_sub_general(inputs)
});